module.exports = __webpack_public_path__ + "img/sicit.de6e69b1.png";